/**
 * Per instructions from Impact,
 * this is a component that installs a global Impact tracking code.
 */

import React from "react";
import { Helmet } from "react-helmet";

const Impact = () => {
  const isBrowser = typeof window !== "undefined";
  var id = "";
  var email = "";
  if (isBrowser) {
    id = localStorage.getItem("shopify_id") || "";
    email = localStorage.getItem("shopify_email") || "";
  }
  return (
    <div>
      <Helmet>
        <script type="text/javascript">
          {`(function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('https://utt.impactcdn.com/A3243087-dae5-4aa5-8171-b8562b476e361.js','script','ire',document,window); 
          ire('identify', {customerId: '${id}', customerEmail: '${email}'});
          `}
        </script>
      </Helmet>
    </div>
  );
};

export default Impact;
